import { createContext, useContext } from 'react';

export type MetaFieldsContextValue = {
  actions: any;
  ignoredFields: string[];
  metaFieldValues: { [key: string]: string };
  globalFields: string[];
  editField: number;
  onAddField: () => void;
  onChangeField: (fieldName: string, value: string) => void;
  onEditField: (arg: number) => void;
  onRemoveField: (fieldName: string) => void;
  onSubmit: () => void;
  onSubmitField: (evt: React.FocusEvent<HTMLInputElement>) => void;
};

export const MetaFieldsContext = createContext<MetaFieldsContextValue | null>(null);

export const useMetaFields = () => {
  const ctx = useContext(MetaFieldsContext);

  if (!ctx) {
    throw new Error('useMetaFields must be used within a MetaFieldsProvider component');
  }

  return ctx;
};
